'use client';

import { useContext } from 'react';
import { DesitnationCollection } from './DesitnationCollection';

export function useDesitnationCollection() {
  const ctx = useContext(DesitnationCollection);
  if (!ctx) {
    throw new Error('useSiteMeta / useDictionary måste användas inom <DesitnationCollectionProvider>.');
  }
  return ctx;
}
